import { CandidateWorkflowPageComponent } from "./candidate-job-matches-workflow-page.component";
import { CandidateJobMatchesWorkflowModule } from "./candidateJobMatchesWorkflow/candidate-job-matches-workflow.module";
export var CandidateJobMatchesWorkflowPageModule = angular
    .module('candidateJobMatchesWorkflowPage', [CandidateJobMatchesWorkflowModule])
    .config(['$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('missioncontrol.candidateJobMatchesWorkflow', {
            url: '/candidateJobMatchesWorkflow',
            component: CandidateWorkflowPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                jobId: null,
                jobMatchId: null,
                searchString: null,
                visibilityFiltersObject: null,
                reqStateData: null
            }
        });
    }
])
    .component(CandidateWorkflowPageComponent.selector, CandidateWorkflowPageComponent.component)
    .name;
//# sourceMappingURL=candidate-job-matches-workflow-page.module.js.map